export const getCookieValue = function (key: string): string | undefined {
  return document.cookie.split('; ')?.find((pair: string) => pair.indexOf(key.concat('=')) === 0)?.split('=')[1];
};

export default { getCookieValue };
